
import { FormCheck, Table } from 'react-bootstrap';
import { MiembroComiteType } from './ComiteMiembrosPopup';
import styled from 'styled-components';
import { PointerSpan } from '../../../../CompUtils/PointerSpan';

const FlexendDiv = styled.div`
  display: flex !important;
  justify-content: flex-end;
`;

type Props = { presentes: MiembroComiteType[], values:any, setValues: any };
export const PresentesForm = (props: Props) => {
  const { presentes, values, setValues } = props;

  return (
    <>
      <Table className=" justify-content-center align-items-center" striped bordered hover>
        <thead>
          <tr>
            <th>Representación</th>
            <th>Apellido</th>
            <th>Nombre</th>
            <th>CUIL</th>
            <th>Presente</th>
          </tr>
        </thead>
        <tbody>
          {presentes.map(
            ({ cuil, nombre, apellido, comite_rol_nombre, titular, idUsuarioComite }) => {
              return (
                <tr
                  key={cuil}
                  onClick={() => setValues({...values, [idUsuarioComite]: !values[idUsuarioComite].presente})}>
                  <td>{`${comite_rol_nombre} - ${titular ? 'Titular' : 'Alterno'}`}</td>
                  <td>{apellido}</td>
                  <td>{nombre}</td>
                  <td>{cuil}</td>
                  <td>
                    <FormCheck id={`${idUsuarioComite}_presente`} type='checkbox' checked={values[idUsuarioComite].presente} onChange={() => setValues({...values, [idUsuarioComite]: !values[idUsuarioComite].presente})}/>
                  </td>
                </tr>
              );
            },
          )}
        </tbody>
      </Table>
      <FlexendDiv>
        <PointerSpan
          onClick={() => setValues({ ...values, vistaPublica: !values.vistaPublica })}>
          Es acta pública
        </PointerSpan>
        <FormCheck id={'vistaPublica'} type='checkbox' checked={values.vistaPublica} onChange={() => setValues({...values, vistaPublica: !values.vistaPublica})} />
      </FlexendDiv>
    </>
  );
};
